import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export type BankKind = 'bank' | 'wallet';

export interface BankItem {
  _id: string;
  shortCode: string;
  bankName: string;
  kind: BankKind;
  accountNumber: string;
  accountName: string;
  instructions: string[];
  isActive: boolean;
  withdrawEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBankInput {
  shortCode: string;
  bankName: string;
  kind: BankKind;
  accountNumber: string;
  accountName: string;
  instructions?: string[];
  isActive?: boolean;
  withdrawEnabled?: boolean;
}

export type UpdateBankInput = Partial<Omit<CreateBankInput, 'shortCode'>>;

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class BankService {
  async getAll(): Promise<BankItem[]> {
    const res = await apiClient.get<ApiEnvelope<BankItem[]>>(
      API_ENDPOINTS.BANKS.GET_ALL
    );
    return res.data.data;
  }

  async create(input: CreateBankInput): Promise<BankItem> {
    const res = await apiClient.post<ApiEnvelope<BankItem>>(
      API_ENDPOINTS.BANKS.CREATE,
      input
    );
    return res.data.data;
  }

  async update(id: string, input: UpdateBankInput): Promise<BankItem> {
    const res = await apiClient.put<ApiEnvelope<BankItem>>(
      API_ENDPOINTS.BANKS.UPDATE(id),
      input
    );
    return res.data.data;
  }

  async remove(id: string): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.BANKS.DELETE(id));
  }

  async toggleActive(id: string): Promise<{ id: string; isActive: boolean }> {
    const res = await apiClient.patch<
      ApiEnvelope<{ id: string; isActive: boolean }>
    >(API_ENDPOINTS.BANKS.TOGGLE_ACTIVE(id));
    return res.data.data;
  }
}

const bankService = new BankService();
export default bankService;